import React from "react";
import FormButton from "../FormBtn/FormButton";

import imgAlertFailure from "./assets/imgAlertFailure.png";
import {
  AlertDesc,
  AlertFailureBox,
  AlertFailureInner,
  AlertImg,
  AlertImgWrapper,
  AlertTitle,
} from "./styled";

const AlertFailure = () => {
  return (
    <AlertFailureBox>
      <AlertFailureInner>
        <AlertImgWrapper>
          <AlertImg src={imgAlertFailure} alt="Радио не работает" />
        </AlertImgWrapper>
        <AlertTitle>Радио сломалось</AlertTitle>
        <AlertDesc>
          У нас возникли технические проблемы, поэтому сейчас послушать музыку
          не получится. Мы работаем над устранением проблемы и скоро все
          починим, возвращайтесь через пару минут.
        </AlertDesc>
        <FormButton
          textBtn="Перезагрузить страницу"
          onClick={() => window.location.reload()}
        />
      </AlertFailureInner>
    </AlertFailureBox>
  );
};

export default AlertFailure;
